import { render } from "./ContactosView.vue?vue&type=template&id=074f3874&scoped=true"
import script from "./ContactosView.vue?vue&type=script&lang=js"
export * from "./ContactosView.vue?vue&type=script&lang=js"

import "./ContactosView.vue?vue&type=style&index=0&id=074f3874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074f3874"]])

export default __exports__